module.exports = __webpack_public_path__ + "static/media/african-american-woman-black-girl-black-woman-chair-1181414.2539b126.jpg";